/**
 * Filtres collection — tiroir (compteur « Filtrer (n) » + familles couleur).
 * Délégation d’événements : survit au rechargement AJAX de #CollectionAjaxContent.
 */
(function () {
  'use strict';

  function fdsGetPrimaryFilterForm() {
    return (
      document.querySelector('#FilterDrawer .filter-form') ||
      document.querySelector('.fds-filter-drawer .filter-form') ||
      document.querySelector('.filter-form')
    );
  }

  function fdsIsTailleGroup(group) {
    if (!group) return false;
    var title = group.querySelector('.fds-filter-section-title, .filter-group-summary .forma-djr-text');
    var label = title ? title.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
    if (label.indexOf('taille') !== -1 || label === 'size' || label === 'sizes') return true;
    var probe = group.querySelector('input[type="checkbox"][name]');
    if (!probe || !probe.name) return false;
    var n = probe.name.toLowerCase();
    return (
      n.indexOf('taille') !== -1 ||
      (n.indexOf('size') !== -1 && n.indexOf('option') !== -1) ||
      n.indexOf('pointure') !== -1
    );
  }

  function fdsPrepareColorFilterForm(form) {
    if (!form || !form.querySelector('.fds-color-family-leader')) return;
    fdsSyncColorFamilyLeaders(form);
    fdsSyncLeadersToMembers(form);
  }

  function fdsBuildFilterSearchParamsFromForm(formEl) {
    var params = new URLSearchParams();
    var preserved = ['sort_by', 'q', 'options[prefix]', 'type'];
    var current = new URLSearchParams(window.location.search);
    var seen = {};

    preserved.forEach(function (k) {
      current.getAll(k).forEach(function (v) {
        params.append(k, v);
      });
    });

    formEl.querySelectorAll('input[type="hidden"][name]').forEach(function (inp) {
      if (inp.value !== '') params.append(inp.name, inp.value);
    });

    function appendUnique(name, value) {
      if (!name || value === '') return;
      var token = name + '\x00' + value;
      if (seen[token]) return;
      seen[token] = true;
      params.append(name, value);
    }

    if (formEl.querySelector('.fds-color-family-leader')) {
      formEl.querySelectorAll('input.fds-color-family-leader:checked').forEach(function (leader) {
        var fam = leader.getAttribute('data-fds-family');
        if (!fam) return;
        formEl.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
          if (!m.disabled && m.name) appendUnique(m.name, m.value);
        });
      });
      formEl.querySelectorAll('input.fds-color-family-member:checked').forEach(function (m) {
        if (!m.disabled && m.name) appendUnique(m.name, m.value);
      });
    }

    formEl.querySelectorAll('input[type="checkbox"][name]:checked').forEach(function (cb) {
      if (cb.disabled) return;
      if (cb.classList.contains('fds-color-family-leader') || cb.classList.contains('fds-color-family-member')) return;
      appendUnique(cb.name, cb.value);
    });

    return params;
  }

  function fdsSyncLeadersToMembers(form) {
    if (!form || form.getAttribute('data-fds-family-syncing') === '1') return;
    form.setAttribute('data-fds-family-syncing', '1');
    form.querySelectorAll('input.fds-color-family-leader').forEach(function (leader) {
      var fam = leader.getAttribute('data-fds-family');
      if (!fam) return;
      form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
        if (m.disabled) return;
        m.checked = leader.checked;
        m.classList.toggle('checked', m.checked);
      });
      leader.classList.toggle('checked', leader.checked);
    });
    form.removeAttribute('data-fds-family-syncing');
  }

  function fdsSyncColorFamilyLeaders(form) {
    if (!form || form.getAttribute('data-fds-family-syncing') === '1') return;
    form.querySelectorAll('input.fds-color-family-leader').forEach(function (leader) {
      var fam = leader.getAttribute('data-fds-family');
      if (!fam) return;
      var any = false;
      form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
        if (m.checked && !m.disabled) any = true;
      });
      leader.checked = any;
      leader.classList.toggle('checked', any);
    });
  }

  function fdsActiveFilterCount(form) {
    if (!form) return 0;
    if (form.querySelector('input.fds-sd-color-direct')) {
      var sdTotal = form.querySelectorAll('input.fds-sd-color-direct:checked').length;
      form.querySelectorAll('details.filter-group').forEach(function (group) {
        if (!fdsIsTailleGroup(group)) return;
        group.querySelectorAll('input[type="checkbox"]:checked').forEach(function () {
          sdTotal += 1;
        });
      });
      return sdTotal;
    }
    if (form.querySelector('.fds-color-family-leader')) {
      var total = form.querySelectorAll('.fds-color-family-leader:checked').length;
      form.querySelectorAll('details.filter-group').forEach(function (group) {
        if (!fdsIsTailleGroup(group)) return;
        group.querySelectorAll('input[type="checkbox"]:checked').forEach(function () {
          total += 1;
        });
      });
      return total;
    }
    var n = 0;
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      if (!cb.classList.contains('fds-color-family-member')) n += 1;
    });
    return n;
  }

  function fdsUpdateDrawerTitleCount(totalActiveFilters) {
    document.querySelectorAll('[data-fds-filter-drawer-count-num]').forEach(function (el) {
      el.textContent = String(totalActiveFilters);
    });
    document.querySelectorAll('[data-fds-filter-drawer-count-wrap]').forEach(function (wrap) {
      wrap.hidden = totalActiveFilters === 0;
    });
  }

  function fdsSyncCheckedClasses(form) {
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.classList.toggle('checked', cb.checked);
    });
  }

  function fdsUpdateFilterToolbarState(skipLeaderSync) {
    if (!skipLeaderSync) {
      document.querySelectorAll('.filter-form').forEach(function (form) {
        if (form.querySelector('.fds-color-family-leader')) {
          fdsSyncColorFamilyLeaders(form);
        }
      });
    }

    var form = fdsGetPrimaryFilterForm();
    var totalActiveFilters = fdsActiveFilterCount(form);
    var filterButton =
      document.querySelector('.js-drawer-open-collection-filters') || document.getElementById('filter-button');
    var gridCustom = document.querySelector('#grid__custom');
    var filterIcon =
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"/></svg>';

    if (filterButton) {
      filterButton.classList.toggle('btn--tertiary-active', totalActiveFilters > 0);
      var counterText = totalActiveFilters > 0 ? ' (' + totalActiveFilters + ')' : '';
      var baseLabel = filterButton.getAttribute('data-fds-filter-label') || 'Filtres';
      filterButton.innerHTML = filterIcon + ' ' + baseLabel + counterText;
    }

    if (gridCustom) {
      gridCustom.classList.toggle('filtre-actif', totalActiveFilters > 0);
    }

    fdsUpdateDrawerTitleCount(totalActiveFilters);
  }

  function fdsHandleLeaderChange(form, leader) {
    var fam = leader.getAttribute('data-fds-family');
    if (!fam) return;
    form.setAttribute('data-fds-family-syncing', '1');
    form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
      if (!m.disabled) {
        m.checked = leader.checked;
        m.classList.toggle('checked', m.checked);
      }
    });
    form.removeAttribute('data-fds-family-syncing');
    leader.classList.toggle('checked', leader.checked);
    fdsUpdateFilterToolbarState(true);
  }

  function fdsOnFilterCheckboxChange(e) {
    var t = e.target;
    if (!t || t.type !== 'checkbox') return;
    var form = t.closest('form.filter-form');
    if (!form) return;

    if (t.classList.contains('fds-color-family-leader')) {
      fdsHandleLeaderChange(form, t);
      return;
    }

    if (t.classList.contains('fds-color-family-member')) {
      if (form.getAttribute('data-fds-family-syncing') === '1') return;
      fdsSyncColorFamilyLeaders(form);
      t.classList.toggle('checked', t.checked);
      fdsUpdateFilterToolbarState(false);
      return;
    }

    if (form.getAttribute('data-fds-family-syncing') === '1') return;
    t.classList.toggle('checked', t.checked);
    fdsUpdateFilterToolbarState(false);
  }

  function fdsEscapeId(id) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(id);
    }
    return String(id).replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  function fdsOnColorPillClick(e) {
    var label = e.target.closest('label.fds-color-family-pill');
    if (!label) return;
    var form = label.closest('form.filter-form');
    if (!form) return;
    var forId = label.getAttribute('for');
    if (!forId) return;
    var leader = form.querySelector('#' + fdsEscapeId(forId));
    if (!leader || !leader.classList.contains('fds-color-family-leader')) return;

    var externalTarget = document.getElementById(forId);
    if (externalTarget && externalTarget !== leader && !form.contains(externalTarget)) {
      e.preventDefault();
      leader.checked = !leader.checked;
      fdsHandleLeaderChange(form, leader);
    }
  }

  function fdsInitFilterForms() {
    document.querySelectorAll('.filter-form').forEach(function (form) {
      fdsSyncCheckedClasses(form);
      if (form.querySelector('.fds-color-family-leader')) {
        fdsSyncColorFamilyLeaders(form);
      }
    });
    fdsUpdateFilterToolbarState(false);
  }

  function fdsBind() {
    if (window.__fdsCollectionFilterDrawerBound) return;
    window.__fdsCollectionFilterDrawerBound = true;

    document.addEventListener('change', fdsOnFilterCheckboxChange);
    document.addEventListener('click', fdsOnColorPillClick);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-apply-filters');
      if (!btn) return;
      var form = btn.closest('form.filter-form');
      if (form) fdsSyncColorFamilyLeaders(form);
    });

    fdsInitFilterForms();
    document.addEventListener('collection:reloaded', fdsInitFilterForms);
  }

  window.fdsUpdateCollectionFilterToolbarState = fdsUpdateFilterToolbarState;
  window.fdsSyncColorFamilyLeadersToMembers = fdsSyncLeadersToMembers;
  window.fdsPrepareColorFilterForm = fdsPrepareColorFilterForm;
  window.fdsBuildFilterSearchParamsFromForm = fdsBuildFilterSearchParamsFromForm;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fdsBind);
  } else {
    fdsBind();
  }
})();
